<template>
  <RequireAdContract>
    <Content
      class="keyword-planner"
      :title="$t('ADVERTISEMENT.KEYWORDPLANNER.TITLE')"
    >
      <Transition name="fade-transform" mode="out-in">
        <KeywordPlannerChooseKeywords
          v-if="!showResult"
          :is-loading="isLoading"
          @submit="saveKeywordsThenSearch"
        />
        <KeywordPlannerResult
          v-if="showResult"
          :data="data"
          :selected-keywords="selectedKeywords"
          :is-loading="isLoading"
          :total="total"
          @change-current="changeCurrentPageAndSearchKeywords"
          @change-size="changeCurrentSizeAndSearchKeywords"
          @submit-keywords-form="saveKeywordsThenSearch"
        />
      </Transition>
    </Content>
  </RequireAdContract>
</template>

<script>
import RequireAdContract from '../common/RequireAdContract';
import Content from '@@/common/layout/Content';
import {
  AD_KEYWORD_PLANNER_SEARCH_BUTTON,
  AD_KEYWORD_PLANNER_GO_TO_RESULT_PAGE,
} from '@/constants/gtm-events';

import KeywordPlannerChooseKeywords from './KeywordPlannerChooseKeywords';
import KeywordPlannerResult from './KeywordPlannerResult';

import { KeywordPlanner } from '@/api/api';
import {
  transformPageOptions,
  transformDataToTableData,
} from './keywordPlannerTransformers';

export default {
  name: 'KeywordPlanner',
  components: {
    Content,
    KeywordPlannerChooseKeywords,
    KeywordPlannerResult,
    RequireAdContract,
  },
  data() {
    return {
      showResult: false,
      selectedKeywords: [],
      currentPage: 1,
      size: 10,
      data: [],
      isLoading: false,
      total: 0,
    };
  },
  methods: {
    changeCurrentPageAndSearchKeywords(page) {
      this.currentPage = page;

      this.searchKeywords();
    },
    changeCurrentSizeAndSearchKeywords(size) {
      this.size = size;

      this.searchKeywords();
    },
    saveKeywordsThenSearch(keywords) {
      this.selectedKeywords = keywords;

      this.searchKeywords();
    },
    searchKeywords() {
      this.$gtm.trackEvent(AD_KEYWORD_PLANNER_SEARCH_BUTTON);

      this.isLoading = true;
      const { limit, offset } = transformPageOptions({
        perPage: this.size,
        currentPage: this.currentPage,
        selectedKeywordsCount: this.selectedKeywords.length,
      });
      return KeywordPlanner.getKeywordPlannerInsight({
        limit,
        offset,
        selectedQueries: this.selectedKeywords,
      })
        .then(({ startingQueries, suggestedQueries, suggestCount }) => {
          this.total = suggestCount + this.selectedKeywords.length;

          return transformDataToTableData({
            startingQueries,
            suggestedQueries,
            currentPage: this.currentPage,
          });
        })
        .then(data => {
          this.data = data;
          this.showResult = true;

          this.$gtm.trackEvent(AD_KEYWORD_PLANNER_GO_TO_RESULT_PAGE);
        })
        .catch(({ message }) => {
          if (message) this.$message.error(message);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
